$(document).ready(function () {
  if ($('#mfa__setup').length >= 1) {
    $('#chkDownloaded').on('change', function () {
      window._MFA.didUpdateCheckboxes()
    })
    $('#chkLostForeverWarn').on('change', function () {
      window._MFA.didUpdateCheckboxes()
    })
    $('#btnDownloadRecoveryCodes').on('click', function (e) {
      e.preventDefault()
      window._MFA.downloadRecoveryCodes()
      return false
    })
    window._MFA.didUpdateCheckboxes()()
  }
  if ($('#mfa__initial__setup').length >= 1) {
    $('#btnShowSecret').on('click', function (e) {
      $(this).parent().html('<code>' + $(this).attr('data-secret') + '</code>')
      e.preventDefault()
      return false
    })
  }
})

window._MFA = {
  downloadRecoveryCodes: function (e) {
    $('#chkDownloaded').removeAttr('disabled')
    $('#chkLostForeverWarn').removeAttr('disabled')
    window._MFA.downloadStringAsFile('augerconnect-recovery.txt', $('#recoveryCodes').val())
    $('#btnDownloadRecoveryCodes').removeClass('animate__animated')
    setTimeout(function () {
      $('#chkDownloaded').addClass('animate__animated')
      $('#chkLostForeverWarn').addClass('animate__animated')
      $('#chkDownloadedLabel').addClass('animate__animated')
      $('#chkLostForeverWarnLabel').addClass('animate__animated')
      $('#chkDownloaded').addClass('animate__pulse')
      $('#chkLostForeverWarn').addClass('animate__pulse')
      $('#chkDownloadedLabel').addClass('animate__pulse')
      $('#chkLostForeverWarnLabel').addClass('animate__pulse')
    }, 500)
    return false
  },
  didUpdateCheckboxes: function () {
    $('#btnEnable').removeClass('bg-success')
    $('#btnEnable').removeClass('bg-light')
    $('#btnEnable').removeClass('text-white')
    $('#btnEnable').removeClass('text-secondary')
    if ($('#chkDownloaded').is(':checked') && $('#chkLostForeverWarn').is(':checked')) {
      $('#btnEnable').text('Enable Multi-Factor Authentication')
      $('#btnEnable').addClass('bg-success')
      $('#btnEnable').addClass('text-white')
      $('#btnEnable').removeAttr('disabled')
    } else {
      $('#btnEnable').text('Follow the steps above')
      $('#btnEnable').addClass('bg-light')
      $('#btnEnable').addClass('text-secondary')
      $('#btnEnable').attr('disabled', 'disabled')
    }
  },
  downloadStringAsFile: function (filename, text) {
    var element = document.createElement('a')
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text))
    element.setAttribute('download', filename)
    element.style.display = 'none'
    document.body.appendChild(element)
    element.click()
    document.body.removeChild(element)
  },
  disableMfa: function () {
    Swal.fire({
      title: 'Disable Multi-Factor Authentication (MFA)?',
      text: 'Are you sure? Turning off MFA will put your account at risk.',
      icon: 'warning',
      showConfirmButton: true,
      confirmButtonText: 'Disable MFA',
      showCancelButton: true,
      allowEscapeKey: true,
      allowEnterKey: false
    }).then(function (result) {
      if (result.isConfirmed) {
        window._showLoader()
        $.ajax({
          method: 'POST',
          url: '/account/security/disable-mfa'
        }).done(function (data) {
          location.reload()
        }).fail(function (xhr, status) {
          alert('Error: ' + xhr.status)
          location.reload()
        })
      }
    })
    return false
  },
  disableEmailMfa: function () {
    Swal.fire({
      title: 'Disable Multi-Factor Authentication Email Option?',
      text: 'If you lose your multi-factor authentication device, and you no longer have your backup codes, this is your last available option to access your account.\n\nAre you sure you want to disable this backup method?',
      icon: 'warning',
      showConfirmButton: true,
      confirmButtonText: 'Disable Recovery Option',
      showCancelButton: true,
      allowEscapeKey: true,
      allowEnterKey: false
    }).then(function (result) {
      if (result.isConfirmed) {
        window._showLoader()
        $.ajax({
          method: 'POST',
          url: '/account/security/disable-mfa-email-recovery'
        }).done(function (data) {
          location.reload()
        }).fail(function (xhr, status) {
          alert('Error: ' + xhr.status)
          location.reload()
        })
      }
    })
    return false
  }
}
